<template>
  <BusinessCrud
    title="合同配置"
    :columns="columns"
    :search-fields="searchFields"
    :form-fields="formFields"
    :list-api="getContractTemplateList"
    :save-api="saveContractTemplate"
    :delete-api="deleteContractTemplate"
    :defaults="{ templateType: '订单合同', contractTitle: '商城订单合同', taxRate: 13, status: 1 }"
    :modal-width="900"
  />
</template>

<script>
import BusinessCrud from '@/components/BusinessCrud'
import { getContractTemplateList, saveContractTemplate, deleteContractTemplate } from '@/api'

export default {
  components: { BusinessCrud },
  data() {
    return {
      getContractTemplateList,
      saveContractTemplate,
      deleteContractTemplate,
      searchFields: [
        { key: 'name', label: '模板名称' },
        { key: 'status', label: '状态', type: 'select', options: [{ label: '启用', value: 1 }, { label: '停用', value: 0 }] }
      ],
      columns: [
        { title: '模板名称', dataIndex: 'name' },
        { title: '合同标题', dataIndex: 'contractTitle' },
        { title: '供方名称', dataIndex: 'supplierName' },
        { title: '税率(%)', dataIndex: 'taxRate' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } }
      ],
      formFields: [
        { key: 'name', label: '模板名称' },
        { key: 'contractTitle', label: '合同标题' },
        { key: 'taxRate', label: '税率(%)', type: 'number', min: 0, precision: 2 },
        { key: 'supplierName', label: '供方名称' },
        { key: 'supplierAddress', label: '供方地址' },
        { key: 'supplierContact', label: '供方联系人' },
        { key: 'supplierPhone', label: '供方电话' },
        { key: 'sealImage', label: '合同印章', type: 'upload-image' },
        { key: 'content', label: '合同条款', type: 'textarea', rows: 14 },
        { key: 'status', label: '状态', type: 'switch' }
      ]
    }
  }
}
</script>
